import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'contracts/:guid',
    loadChildren: () => import('./contract-flow').then((module) => module.ContractFlowModule),
  },
  {
    path: 'financing-options',
    loadChildren: () => import('./advancements-options/advancements-options.module').then((module) => module.AdvancementsOptionsModule),
  },
  {
    path: 'sellers',
    loadChildren: () => import('./seller').then((module) => module.SellerModule),
  },
  { path: 'not-found', component: PageNotFoundComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
